import React from "react";

type Props = {
  label: string;
  name: string;
  value: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
};

const CheckboxInput: React.FC<Props> = ({ label, name, value, checked, onChange }) => {
  const id = `${name}-${value}`;
  return (
    <div className="form-check form-check--choice">
      <input
        id={id}
        type="checkbox"
        name={name}
        value={value}
        className="form-check-input"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
      />
      <label className="form-check-label" htmlFor={id}>{label}</label>
    </div>
  );
};

export default CheckboxInput;
